import { LOAD_PROFILE } from './constants';

export function loadProfile(fields) {
  return {
    type: LOAD_PROFILE,
    fields,
  };
}



/** WEBPACK FOOTER **
 ** ./src/containers/user-profile/actions.js
 **/